import * as React from 'react';

import { sendCustomEvent } from '@Analytics';
import { Button, ButtonProps } from '@Components/ui-v2/button';

export interface TrackedButtonProps extends Omit<ButtonProps, 'onClick'> {
  buttonName: string;
  extraLogData?: object;
  isSubmit?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const TrackedButton = React.forwardRef<HTMLButtonElement, TrackedButtonProps>(
  ({ buttonName, extraLogData, isSubmit, onClick, type, ...props }, ref) => {
    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
      sendCustomEvent('BUTTON_CLICKED', { buttonName, ...(extraLogData || {}) });
      onClick?.(e);
    };

    return <Button ref={ref} type={type ?? (isSubmit ? 'submit' : 'button')} onClick={handleClick} {...props} />;
  },
);
TrackedButton.displayName = 'TrackedButton';

export { TrackedButton };
